import { ChangeEvent, useCallback } from 'react';
import { produce } from 'immer';
import { css } from '@emotion/react';
import { ProjectState, useProjectState } from 'client/state/ProjectState';
import { Input } from 'client/components/Input';

const nameInputStyle = css`
  margin-bottom: 0 !important;
`;

export const ProjectGeneral = () => {
  const name = useProjectState((state) => state.document?.name || '');

  const handleNameChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) =>
      useProjectState.setState(
        produce<ProjectState>((state) => {
          if (!state.document) return;
          state.document.name = event.target.value;
          return state;
        })
      ),
    []
  );

  return (
    <>
      <Input path="name" label="Name" value={name} large disableAutocomplete onChange={handleNameChange} css={nameInputStyle} />
    </>
  );
};
